(function ($) {
    var halo = {
        initBlogPostSlider: function () {
            var blogBlock = $('[data-blogs-slider]');

            if (!blogBlock.length) return; // Prevent running if the selector doesn't exist

            blogBlock.each(function () {
                var self = $(this);

                // Destroy existing Slick instance to prevent duplication
                if (self.hasClass('slick-initialized')) {
                    self.slick('unslick');
                }
            });

            blogBlock.each(function () {
                var self = $(this),
                    rows = self.data('rows') || 3; // Default to 3 if undefined

                if (!self.hasClass('slick-initialized')) {
                    self.slick({
                        slidesToShow: rows,
                        slidesToScroll: 1,
                        speed: 1000,
                        autoplay: false,
                        infinite: false,
                        dots: false,
                        arrows: true,
                        nextArrow: window.arrows?.icon_next || '<button type="button" class="slick-next">→</button>',
                        prevArrow: window.arrows?.icon_prev || '<button type="button" class="slick-prev">←</button>',
                        rtl: window.rtl_slick || false,
                        responsive: [
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 2,
                                    dots: true,
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1.2, // Show partial second slide for better design
                                    slidesToScroll: 1,
                                    dots: true,
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 375,
                                settings: {
                                    slidesToShow: 1, // Show full single slide at 375px
                                    slidesToScroll: 1,
                                    dots: true,
                                    arrows: false
                                }
                            }
                        ]
                    });
                }
            });

            // Refresh Slick after load
            setTimeout(function () {
                blogBlock.slick('refresh');
            }, 1000);
        }
    };

    // Initialize after full load
    $(window).on('load', function () {
        setTimeout(function () {
            halo.initBlogPostSlider();
        }, 500);
    });

    // Backup: Initialize when document is ready
    $(document).ready(function () {
        setTimeout(function () {
            halo.initBlogPostSlider();
        }, 500);
    });

    // Refresh on resize
    $(window).on('resize', function () {
        setTimeout(function () {
            $('[data-blogs-slider]').slick('refresh');
        }, 500);
    });

})(jQuery);
